import type { Announcement } from '../types';

export const a_2026_06_21: Announcement = {
  id: '2026-06-21-nouvelle-interface-hector',
  date: '2026-06-21',
  layout: 'spotlight',
  kicker: 'Mise à jour produit · 21 juin 2026',
  title: "Hector s'améliore :",
  navLabel: 'Nouvelle interface',
  subtitle: 'La nouvelle interface graphique',
  intro: [
    "Nous avons revu l'interface d'Hector pour vous offrir un espace de travail plus premium, où les options sont plus claires, plus accessibles et mieux organisées autour de votre pratique.",
    "Cette refonte graphique ne change pas vos principaux repères : les interactions restent globalement les mêmes, afin que vous retrouviez rapidement votre manière habituelle de travailler.",
  ],
  sections: [],
};
